import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { NextRacesState } from 'src/domains/sportsbook/webview/components/nextRaces/NextRaces.state';
import {
    SwitchLabel,
    SwitchWrapper,
} from 'src/domains/sportsbook/webview/components/nextRaces/racesSlider/NextRacesSlider.style';
import { Toggle } from 'src/components/toggle/Toggle';
import { useCommon } from 'src/domains/common/Common';

interface TogglePropsType {
    nextRacesState: NextRacesState;
}
export const RacesRegionToggle = observer('RacesRegionToggle', (props: TogglePropsType) => {
    const common = useCommon();
    const { nextOffSwitchVariant } = common.features.componentVariants;

    const { toggleRacesRegion, hideToggle, isRacesRegionSelected } = props.nextRacesState;

    if (hideToggle) {
        return null;
    }

    return (
        <SwitchWrapper>
            <SwitchLabel>
                <I18n
                    langKey='races-slider.header.switch-uk-ireland-only'
                    defaultText='UK & Ireland Only'
                />
            </SwitchLabel>

            <Toggle
                toggleActive={toggleRacesRegion}
                isActive={isRacesRegionSelected}
                variant={nextOffSwitchVariant}
            />
        </SwitchWrapper>
    );
});
